import i18n from '@/lang/index'
export const footerList = [
  {
    prop: "totalAmount",
    label: i18n.t("components.sizeGroupTableTotalAmount"),
    unit: i18n.t("components.sizeGroupTableUnitPiece"),
    formula(data) {
      return new Set(data.map((i) => i.goodsNo)).size || 0;
    },
  },
  {
    prop: "getNum",
    label: i18n.t("components.sizeGroupTableTotalPieces"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.number || 0),
          0
        );
        num += all;
      });
      return num;
    },
  },
  {
    prop: "rkbdGetNum", //提货-入库补单//提货-采购计划提货
    label: i18n.t("components.sizeGroupTableTotalPieces"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.takeGoodsNumber || 0),
          0
        );
        num += all;
      });
      return num;
    },
  },

  {
    prop: "rkbdNumTotal", //提货-入库补单//提货-采购计划提货
    label: i18n.t("components.sizeGroupTableTotalPrice"),
    unit: "amount",
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.takeGoodsNumber || 0),
          0
        );
        num += item.purchasePrice * all;
      });
      return num;
    },
  },
  {
    prop: 'dbGetNum',
    label: i18n.t('components.sizeGroupTableTransferTotalPieces'),
    unit: i18n.t('components.sizeGroupTableUnitItem'),
    formula(data) {
        let num = 0
        data.forEach((item) => {
            let phAll = item.sizeInfoList.reduce((c, R) => c + Number(R.totalNum || 0), 0)
            num += phAll
        })
        return num
    }
},
  {
    prop: "tcGetNum",
    label: i18n.t("components.sizeGroupTableReturnWarehouseTotalPieces"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.num || 0),
          0
        );
        num += all;
      });
      return num;
    },
  },
  {
    prop: "phGetNum",
    label: i18n.t("components.sizeGroupTableDistributionTotalPieces"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let phAll = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.number || 0),
          0
        );
        num += phAll;
      });
      return num;
    },
  },
  {
    prop: "cgDistriPriceTotal", //采购单的采购总价
    label: i18n.t("components.sizeGroupTablePurchaseTotalPrice"),
    unit: "amount",
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.purchaseNumber || 0),
          0
        );
        num += item.purchasePrice * all;
      });
      return num.toFixed(2);
    },
  },
  {
    prop: "thDistriPriceTotal", //用于提货单--采购总价
    label: i18n.t("components.sizeGroupTablePurchaseTotalPrice"),
    unit: "amount",
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.takeGoodsNumber || 0),
          0
        );
        num += item.purchasePrice * all;
      });
      return num.toFixed(2);
    },
  },
  {
    prop: "tgDistriPriceTotal", //用于退供单---采购总价
    label: i18n.t("components.sizeGroupTablePurchaseTotalPrice"),
    unit: "amount",
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.shipmentNumber || 0),
          0
        );
        num += item.purchasePrice * all;
      });
      return num.toFixed(2);
    },
  },
  {
    prop: "tagDistriPriceTotal", //提货-吊牌总价
    label: i18n.t("components.sizeGroupTableTagTotalPrice"),
    unit: "amount",
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.takeGoodsNumber || 0),
          0
        );
        num += item.retailPrice * all;
      });
      return num;
    },
  },
  {
    prop: "dbDistriPriceTotal",
    label: i18n.t("components.sizeGroupTableTransferTotalPrice"),
    unit: "amount",
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.number || 0),
          0
        );
        num += item.price * all;
      });
      return num.toFixed(2);
    },
  },
  {
    prop: "tcDistriPriceTotal",
    label: i18n.t("components.sizeGroupTableReturnWarehouseTotalPrice"),
    unit: "amount",
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.number || 0),
          0
        );
        num += item.price * all;
      });
      return num.toFixed(2);
    },
  },
  {
    prop: "phDistriPriceTotal",
    label: i18n.t("components.sizeGroupTableDistributionTotalPrice"),
    unit: "amount",
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let phAll = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.number || 0),
          0
        );
        num += item.price * phAll;
      });
      return num.toFixed(2);
    },
  },
  {
    prop: "sellPriceTotal",
    label: i18n.t("components.sizeGroupTableRetailTotalPrice"),
    unit: "amount",
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let phAll = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.number || 0),
          0
        );
        num += item.retailPrice * phAll;
      });
      return num.toFixed(2);
    },
  },
  {
    prop: "checkGetNum", //验收
    label: i18n.t("components.sizeGroupTableTotalPieces"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.number || 0),
          0
        );
        num += all;
      });
      return num;
    },
  },

  {
    prop: "ReceivedTotal",
    label: i18n.t("components.sizeGroupTableReceived"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.checkNum || 0),
          0
        );
        num += all;
      });
      return num;
    },
  },
  {
    prop: "noReceivedTotal",
    label: i18n.t("components.sizeGroupTableNotReceived"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.noCheckNum || 0),
          0
        );
        num += all;
      });
      return num;
    },
  },
  {
    prop: "chuhdNumTotal",
    label: i18n.t("components.sizeGroupTableShipmentDifferenceTotal"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let chAll = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.outNumDifference || 0),
          0
        );
        num += chAll;
      });
      return num;
    },
  },
  {
    prop: "PHchuhdNumTotal",
    label: i18n.t("components.sizeGroupTableShipmentDifferenceTotal"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let chAll = item.sizeInfoList.reduce(
            (c, R) => c + Number(R.shipmentDifferenceNumber || 0),
            0
        );
        num += chAll;
      });
      return num;
    },
  },
  {
    prop: 'PHrukudNumTotal',
    label: i18n.t('components.sizeGroupTableStorageDifferenceTotal'),
    unit: i18n.t('components.sizeGroupTableUnitItem'),
    formula(data) {
      let num = 0
      data.forEach((item) => {
        let rkAll = item.sizeInfoList.reduce((c, R) => c + Number(R.storageDifferenceNumber || 0), 0)
        num += rkAll
      })
      return num
    }
  },

  // 店铺调出单详情尺码组底部

  {
    prop: "totalDBAmount",
    label: i18n.t("components.sizeGroupTableTotalAmount"),
    unit: i18n.t("components.sizeGroupTableUnitPiece"),
    formula(data) {
      return new Set(data.map((i) => i.goodsNo)).size || 0;
    },
  },
  {
    prop: 'DBGetNum',
    label: i18n.t('components.sizeGroupTableTransferTotalPieces'),
    unit: i18n.t('components.sizeGroupTableUnitItem'),
    formula(data) {
        let num = 0
        data.forEach((item) => {
            let phAll = item.sizeInfoList.reduce((c, R) => c + Number(R.totalNum || 0), 0)
            num += phAll
        })
        return num
    }
},


  {
    prop: 'rukudNumTotal',
    label: i18n.t('components.sizeGroupTableStorageDifferenceTotal'),
    unit: i18n.t('components.sizeGroupTableUnitItem'),
    formula(data) {
        let num = 0
        data.forEach((item) => {
            let rkAll = item.sizeInfoList.reduce((c, R) => c + Number(R.inNumDifference || 0), 0)
            num += rkAll
        })
        return num
    }
},
{
  prop: "chuhdbNumTotal",
  label: i18n.t("components.sizeGroupTableShipmentDifferenceTotal"),
  unit: i18n.t("components.sizeGroupTableUnitItem"),
  formula(data) {
    let num = 0;
    data.forEach((item) => {
      let chAll = item.sizeInfoList.reduce(
        (c, R) => c + Number(R.outNumDifference || 0),
        0
      );
      num += chAll;
    });
    return num;
  },
},
  {
    prop: "rukudbNumTotal",
    label: i18n.t("components.sizeGroupTableStorageDifferenceTotal"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let rkAll = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.storageDifferenceNumber || 0),
          0
        );
        num += rkAll;
      });
      return num;
    },
  },
  {
    prop: "cukudNumTotal",
    label: i18n.t("components.sizeGroupTableOutboundDifferenceTotal"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let ckAll = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.shipmentDifferenceNumber || 0),
          0
        );
        num += ckAll;
      });
      return num;
    },
  },
  {
    prop: "adjustTotal",
    label: i18n.t("components.sizeGroupTableAdjustTotalPieces"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.number || 0),
          0
        );
        num += all;
      });
      return num;
    },
  },
  {
    prop: "tackNum",
    label: i18n.t("components.sizeGroupTableTakenQuantity"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.takeGoodsNumber || 0),
          0
        );
        num += all;
      });
      return num;
    },
  },
  {
    prop: "notackNum",
    label: i18n.t("components.sizeGroupTableNotTakenQuantity"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.notTakeGoodsNumber || 0),
          0
        );
        num += all;
      });
      return num;
    },
  },
  {
    prop: "intoNum",
    label: i18n.t("components.sizeGroupTableStorageQuantity"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.intoStockNumber || 0),
          0
        );
        num += all;
      });
      return num;
    },
  },

  {
    prop: "returnNum",
    label: i18n.t("components.sizeGroupTableReturnSupplierQuantity"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.returnGoodsNumber || 0),
          0
        );
        num += all;
      });
      return num;
    },
  },
  {
    prop: "returnPrice",
    label: i18n.t("components.sizeGroupTableReturnSupplierAmount"),
    unit: "amount",
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.returnGoodsNumber || 0),
          0
        );
        num += all * item.purchasePrice;
      });
      return num.toFixed(2);
    },
  },
  {
    prop: "pickReceivedTotal", //拣货
    label: i18n.t("components.sizeGroupTablePicked"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.actualPickNumber || 0),
          0
        );
        num += all;
      });
      return num;
    },
  },
  {
    prop: "pickNoReceivedTotal", //拣货
    label: i18n.t("components.sizeGroupTableNotPicked"),
    unit: i18n.t("components.sizeGroupTableUnitItem"),
    formula(data) {
      let num = 0;
      data.forEach((item) => {
        let all = item.sizeInfoList.reduce(
          (c, R) => c + Number(R.notPickNumber || 0),
          0
        );
        num += all;
      });
      return num;
    },
  },
];
